import { type CMSView } from "@firecms/core";

import AdminContentDuration from "components/organisms/AdminContentDuration";
import AdminFeedbackResults from "components/organisms/AdminFeedbackResults";
import AdminOfflineDownloadsCount from "components/organisms/AdminOfflineDownloadsCount";
import AdminSetUserMailVerified from "components/organisms/AdminSetUserMailVerified";
import AdminUserDocumentReport from "components/organisms/AdminUserDocumentReport";

import { Groups } from "../collections/types";

export const adminToolViews: CMSView[] = [
  {
    path: "admin-content-duration",
    name: "Content-Dauer",
    description: "Summierte Dauer veröffentlichter Meditationen und Audio-Kurse",
    icon: "schedule",
    group: Groups.Werkzeuge,
    view: <AdminContentDuration />,
  },
  {
    path: "admin-offline-downloads",
    name: "Offline-Downloads",
    description: "Zähler für Offline-Download-Audit-Einträge",
    icon: "cloud_download",
    group: Groups.Werkzeuge,
    view: <AdminOfflineDownloadsCount />,
  },
  {
    path: "admin-feedback-results",
    name: "Feedback-Auswertung",
    description: "Durchschnittswerte und Freitexte aus der Feedback-Collection",
    icon: "reviews",
    group: Groups.Werkzeuge,
    view: <AdminFeedbackResults />,
  },
  {
    path: "admin-user-lookup",
    name: "Nutzer-Auswertung",
    description: "Nutzerprofil, Auth, Favoriten und Aktivität anhand UID oder E-Mail",
    icon: "person_search",
    group: Groups.Werkzeuge,
    view: <AdminUserDocumentReport />,
  },
  {
    path: "admin-set-mail-verified",
    name: "E-Mail verifizieren",
    description: "E-Mail-Verifizierung für UID oder E-Mail-Adresse setzen",
    icon: "mark_email_read",
    group: Groups.Werkzeuge,
    view: <AdminSetUserMailVerified />,
  },
];
